import { createSelector } from 'reselect'
import {
  selectSelectedGeoentity,
  selectIsTransactionalHotelGeoentity,
  selectReservationLink
} from '../../../store/geoentity/geoentity.selectors'

export const selectRealWebsite = createSelector(selectSelectedGeoentity, geoentity => geoentity?.communication?.website)

export const selectWebsiteUrl = createSelector(
  selectIsTransactionalHotelGeoentity,
  selectRealWebsite,
  selectReservationLink,
  (isTransactionalHotel, realWebsite, reservationLink) => (!isTransactionalHotel ? realWebsite : reservationLink)
)

export const selectEmail = createSelector(selectSelectedGeoentity, geoentity => geoentity?.communication?.email)

export const selectPhone = createSelector(selectSelectedGeoentity, geoentity => geoentity?.communication?.phone)

export const selectIsSpecialPhoneNumber = createSelector(selectPhone, phone => Boolean(phone.category))
